import { green, grey } from "@mui/material/colors";
import { HOME_BODY_COLOR } from "styles/oneOffColor";
import { paragraphFontFamily } from "styles/theme";

const styles = {
  root: {
    position: "sticky",
    top: -1,
    zIndex: 30,
    width: "100%",
    backgroundColor: "white",
    pt: { xs: 0.75, md: 1.5 },
    pb: { xs: 0.75, md: 1.5 },
  },
  formControl: {
    minWidth: "80px",
    maxWidth: {
      md: "120px",
      xl: "None",
    },
  },
  typeFilter: {
    maxWidth: {
      md: "120px",
      xl: "None",
    },
  },
  locationFilter: {
    minWidth: "100px",
    maxWidth: {
      md: "150px",
      xl: "None",
    },
  },
  instagramFollowingFilter: {
    minWidth: "150px",
    maxWidth: {
      md: "180px",
      xl: "None",
    },
  },
  sortLabel: {
    minWidth: "100px",
    maxWidth: {
      md: "180px",
      xl: "None",
    },
  },
  chip: {
    borderRadius: "4px",
    fontSize: "0.625rem",
  },
  collapse: {
    textAlign: "center",
    pt: 2,
    fontSize: "0.8rem",
    width: "100%",
  },
  drawer: {
    minHeight: "100svh",
    width: "80%",
    right: 0,
    position: "fixed",
    borderTopRightRadius: 0,
    borderBottomRightRadius: 0,
  },
  dollarSign: {
    color: grey[500],
  },
  icon: {
    fontSize: { xs: 14, sm: 16 },
    mr: 1,
  },
  paidPartnershipBadge: {
    color: "#32885F",
  },
  worksWithUgcBadge: {
    color: "#388BED",
  },
  worksWithInfluencerBadge: {
    color: "#D45FD1",
  },
  tiktok: {
    color: "#010101",
  },
  ads: {
    color: "#F15E5E",
  },
  emerging: {
    color: "#00BFFF",
  },
  bolt: {
    color: "#786EEB",
  },
  star: {
    color: "#EDDB38",
  },
  nonGeneric: {
    color: "#F6BB75",
  },
  hasContacts: {
    color: "#26A69A",
  },
  neverEmailed: {
    color: green[500],
  },
  notContactedThisMonth: {
    color: "#7FA6C9",
  },
  search: {
    mt: 1,
    border: `1px solid ${grey[400]}`,
    borderRadius: 1,
    height: 30,
    py: 2,
    px: 2,
    width: "100%",
    fontFamily: paragraphFontFamily,
    "&:hover, &:focus": {
      outline: "none",
    },
  },
  pitchLocalButton: {
    px: { xs: 0.5, md: 2 },
    mx: { xs: 1, md: 0 },
    fontSize: { xs: 11, md: 14 },
    backgroundColor: "yellow.main",
    borderRadius: 6,
  },
  upgradeButton: {
    fontSize: 11,
  },
  background: {
    background: HOME_BODY_COLOR,
  },
  mobileList: {
    px: 2,
    py: 1,
    borderBottom: `1px solid ${grey[100]}`,
  },
};

export default styles;
